<template>
    <div  class="alarmsBg">
    
        <div class="tableSelect_alarms" ref="tableSelect">
       
        </div>

        <div class="table">
            <el-table  :height="'calc('+(tableHeight)+'px)'" border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column width="80" type="index" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="30" prop="time" label="时间" align="left"></el-table-column>
                <el-table-column min-width="30" prop="user_name" label="账号" align="left"></el-table-column>

                <el-table-column min-width="60" prop="details" label="操作类型" align="left"></el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

     
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {dateFormats,getTableHeight} from "@/utils/util";
    import {apiOperationlog} from '@/api/api';
   
    import deviceTypeConfig from "@/config"

    export default {
        name:'configManage',
        components:{
            Pagination,
        },
        data() {
            return {
                isFull:false,
                tableHeight:500,
                loadingPage:false,
              
                pageparm: {
                    page: 1,
                    page_size: 10,
                    total: 0
                },

                tableData:[],
                timers:[],
              
                fnParm:{
                    page: 1,
                    page_size: 10,  
                
                    ordering:"processed,-time",         
                },

                tableLineData:{
                },

                startDate:[],
                endDate:[],

            }
        },
        methods:{
            dataChange(item){
                this.tableData.length = 0
                for(let i = 0;i<item.length;i++){
                    this.tableData[i] = {};

                    this.tableData[i] = item[i]   
                }
             
                
            },
           
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },
            setFull(){
                this.isFull=!this.isFull
            },

          
            callFather(parm) {
                this.fnParm.page = parm.page
                this.fnParm.page_size = parm.page_size
                this.fnParm.ordering = "processed,-time",
                this.getData()
            },

         
            //获取列表
            async getData(){
                 this.loadingPage = true

                 apiOperationlog(this.fnParm).then(res => {
                    this.loadingPage = false
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                     
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
                 }).catch(res => {  
                    this.loadingPage = false
                    this.tableData.length = 0
                    this.$message.error(`获取告警列表失败 : ${res.msg}`)
                });           
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
               var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
               this.tableHeight =  getTableHeight(this.$refs.tableSelect.offsetHeight) - 2*bg_padding
            },

         

        },


        created() {
            this.getData()
        },

        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },
        unmounted() {
              // 页面销毁，去掉监听事件
            window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss" scoped>
    .tableNav{
        overflow: hidden;
        margin-bottom: 20px;
    }

    .alarmsBg{
      background: url("@/assets/bigscreen/block_bg.jpg") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      padding: var(--my-css-var-bg-padding);
    }

    .tableSelect_alarms{
        background: var(--l-searchtoolbar-bg);
        padding: 8px;
        display: none;


        border: 1px solid var(--el-border-color-lighter);
        margin-bottom: 8px;

        .el-form-item{
            margin: 5px !important;
        }
    }
</style>
